var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvioMiniCard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 46,
    viewBox: "0 0 65 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#fcfcfc;}.c,.d{fill:#2fffd1;}.c{fill-rule:evenodd;}.e{filter:url(#b);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.398,
    y1: 0.657,
    x2: 1,
    y2: 0.388,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#353841"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5f5f7a"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 0,
    y: 0,
    width: 65,
    height: 46,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.259
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-57 -176.035)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "matrix(1, 0, 0, 1, 57, 176.03)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 47,
    height: 28,
    rx: 4,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.892 191.506) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M6.072.929V.942a.95.95,0,0,0,.305.687,2.851,2.851,0,0,1,.859,2.079v.033a2.593,2.593,0,0,1-2.62,2.734A2.664,2.664,0,0,1,1.981,3.708V3.675a2.823,2.823,0,0,1,.858-2.093A.927.927,0,0,0,3.145.9h0A.9.9,0,0,0,1.671.2,4.475,4.475,0,0,0,0,3.708v.033A4.471,4.471,0,0,0,4.584,8.21a4.52,4.52,0,0,0,4.633-4.5V3.675A4.428,4.428,0,0,0,7.578.207.926.926,0,0,0,6.072.929Z",
    transform: "translate(0.532 9.218) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M0,.841a.841.841,0,1,1,.841.841A.841.841,0,0,1,0,.841",
    transform: "translate(0 5.453) rotate(-90)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.28 29.887) rotate(-90)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M4.183,8.505A4.067,4.067,0,0,1,0,4.276V4.245A4.045,4.045,0,0,1,3.983,0,3.855,3.855,0,0,1,7.857,4.013a.873.873,0,0,1-.88.9H1.868A2.275,2.275,0,0,0,4.214,6.977a2.929,2.929,0,0,0,1.93-.71.7.7,0,0,1,.479-.17.735.735,0,0,1,.741.756.816.816,0,0,1-.247.571A4.185,4.185,0,0,1,4.183,8.505ZM6.036,3.674A2.116,2.116,0,0,0,3.967,1.528,2.206,2.206,0,0,0,1.852,3.674Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M3.983,8.4H3.89a1.16,1.16,0,0,1-1.065-.818L.108,1.358A1.456,1.456,0,0,1,0,.9.934.934,0,0,1,.926,0a.94.94,0,0,1,.926.679l2.1,5.4L6.082.648A.93.93,0,0,1,6.962,0a.89.89,0,0,1,.911.9,1.12,1.12,0,0,1-.108.448L5.048,7.579A1.181,1.181,0,0,1,3.983,8.4Z",
    transform: "translate(8.228 0.077)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,.942A.923.923,0,0,1,.926,0a.936.936,0,0,1,.942.942V7.394a.923.923,0,0,1-.942.926A.919.919,0,0,1,0,7.394Z",
    transform: "translate(17.351 0.077)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvioMiniCard);
export default __webpack_public_path__ + "static/media/evio_mini_card.036c20c3944ef1a72a69338133fa6d4e.svg";
export { ForwardRef as ReactComponent };